module.exports = __webpack_public_path__ + "img/building.d4dd615d.svg";